import { HStack, VStack, Stack, StackDivider } from '@chakra-ui/react';
export const CUIHStack = HStack;
export const CUIVStack = VStack;
export const CUIStack = Stack;
export const CUIStackDivider = StackDivider;